var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClearbit = function SvgClearbit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4D3E0",
    fillOpacity: 0.2,
    d: "M14.655 20.171H4.96c-1.567-.025-2.2-.211-2.822-.56a3.79 3.79 0 0 1-1.579-1.578l-.074-.149C.186 17.275.012 16.591 0 15V5.454c0-1.864.199-2.536.56-3.22A3.72 3.72 0 0 1 2.137.657l.15-.075C2.895.283 3.567.11 5.157.097h9.497c1.852 0 2.523.199 3.207.559a3.79 3.79 0 0 1 1.579 1.579l.074.149c.299.609.473 1.293.485 2.884v9.931c-.025 1.579-.211 2.2-.547 2.834a3.721 3.721 0 0 1-1.578 1.579l-.15.075c-.646.323-1.342.484-3.07.484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clearbit_svg__a)",
    d: "M19.987 10.14v4.674c0 1.864-.198 2.536-.559 3.22a3.721 3.721 0 0 1-1.579 1.578c-.683.36-1.354.56-3.206.56h-4.65V10.14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clearbit_svg__b)",
    d: "M9.994.11h4.649c1.852 0 2.523.198 3.206.558a3.79 3.79 0 0 1 1.58 1.58c.36.683.558 1.354.558 3.218v4.674H9.994z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clearbit_svg__c)",
    d: "M5.345.11h4.649V20.17h-4.65c-1.851 0-2.522-.199-3.206-.56a3.79 3.79 0 0 1-1.579-1.578C.2 17.35 0 16.678 0 14.813V5.467c0-1.864.199-2.535.56-3.219A3.72 3.72 0 0 1 2.137.668C2.822.308 3.493.11 5.345.11"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clearbit_svg__a",
    x1: 12.983,
    x2: 18.011,
    y1: 11.15,
    y2: 21.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clearbit_svg__b",
    x1: 11.328,
    x2: 16.356,
    y1: -0.558,
    y2: 9.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clearbit_svg__c",
    x1: 1.381,
    x2: 9.929,
    y1: 1.301,
    y2: 18.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148CFC"
  })))));
};
export default SvgClearbit;